import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { REGISTRATION_STEP_ID, StepService } from '@shared/services/steps.service';
import { NGXLogger } from 'ngx-logger';

export const completedApplicationGuard: CanActivateFn = (route, state) => {
    let allow = true;

    if (inject(StepService).isStepComplete(REGISTRATION_STEP_ID.TERMS) && !route.data?.canAccessAfterTerms) {
        inject(NGXLogger).warn("Cannot access forms when Terms step is completed!");
        allow = false;
    }

    return allow;
};
